<!-- One Featured placement (PD §3; P/Member_Hub.html:1268-1645), laid out by kind. Copy is the placement's data. -->
<ng-template #tagTpl><span class="agu-ad__tag" [class.agu-ad__tag--agu]="Placement.house">{{ TagText }}</span></ng-template>

<!-- `.fx-logo`: sponsor initials on the sponsor's colour, or the AGU mark on white (P/Member_Hub.html:1279-1282, 1364). -->
<ng-template #logoTpl>
    <span class="agu-ad__logo" [class.agu-ad__logo--lg]="Large" [class.agu-ad__logo--agu]="Placement.logoIsAgu" [style.background]="Placement.logoIsAgu ? null : Placement.logoBg" aria-hidden="true">
        @if (Placement.logoIsAgu) {
            <agu-logo [Height]="Large ? 16 : 13" />
        } @else {
            {{ Placement.logoText }}
        }
    </span>
</ng-template>

<!-- The CTA: a link only when the placement carries an href (none does this round). -->
<ng-template #ctaTpl>
    @if (Placement.href) {
        <a class="agu-ad__cta" [href]="Placement.href" target="_blank" rel="noopener">{{ Placement.cta }}@if (HasArrow) { <agu-icon Name="arrow-right" [Size]="12" /> }</a>
    } @else {
        <span class="agu-ad__cta">{{ Placement.cta }}@if (HasArrow) { <agu-icon Name="arrow-right" [Size]="12" /> }</span>
    }
</ng-template>

<ng-template #closeTpl>
    @if (Dismissible) {
        <button type="button" class="agu-ad__x" aria-label="Hide for this session" (click)="Dismiss()">✕</button>
    }
</ng-template>

<!-- The display ads' sponsor mark: `TERRA<b>ANALYTICS</b>`, or the AGU mark in white (P/Member_Hub.html:1420-1423, 1457-1460). -->
<ng-template #markTpl>
    @if (Placement.logoIsAgu) {
        <agu-logo [Height]="Placement.kind === 'leaderboard' ? 21 : 15" />
        @if (ShowEos) { <b class="agu-ad__eos">Eos</b> }
    } @else {
        {{ MarkFirst }}@if (MarkRest) { <b>{{ MarkRest }}</b> }
    }
</ng-template>

@switch (Placement.kind) {
    @case ('leaderboard') {
        <!-- `.fx-lb` (P/Member_Hub.html:1483-1490) -->
        <div class="agu-ad__lbbar"><span>{{ BarLabel }}</span><span class="agu-ad__end"><ng-container *ngTemplateOutlet="closeTpl" /></span></div>
        <div class="agu-ad__lbad" [style.background]="Placement.logoIsAgu ? null : Placement.logoBg">
            <span class="agu-ad__lbmark" [class.agu-ad__lbmark--agu]="Placement.logoIsAgu"><ng-container *ngTemplateOutlet="markTpl" /></span>
            <span class="agu-ad__lbtx">
                <span class="agu-ad__h">{{ Placement.head }}</span>
                @if (Placement.sub) { <span class="agu-ad__s">{{ Placement.sub }}</span> }
            </span>
            <ng-container *ngTemplateOutlet="ctaTpl" />
        </div>
    }
    @case ('sidebar') {
        <!-- `.fx-sb` (P/Member_Hub.html:1440-1448) -->
        <div class="agu-ad__lbbar"><span>{{ BarLabel }}</span><span class="agu-ad__end"><ng-container *ngTemplateOutlet="closeTpl" /></span></div>
        <div class="agu-ad__sbad" [style.background]="Placement.logoIsAgu ? null : Placement.logoBg">
            <span class="agu-ad__sbmark"><ng-container *ngTemplateOutlet="markTpl" /></span>
            <span class="agu-ad__h">{{ Placement.head }}</span>
            @if (Placement.sub) { <span class="agu-ad__s">{{ Placement.sub }}</span> }
            <ng-container *ngTemplateOutlet="ctaTpl" />
        </div>
    }
    @case ('feature') {
        <!-- `section.fx-feature` (P/Member_Hub.html:1518-1522) -->
        <ng-container *ngTemplateOutlet="logoTpl" />
        <div class="agu-ad__body">
            <div class="agu-ad__meta"><ng-container *ngTemplateOutlet="tagTpl" /></div>
            <h3 class="agu-ad__h">{{ Placement.head }}</h3>
            @if (Placement.sub) { <p class="agu-ad__s">{{ Placement.sub }}</p> }
        </div>
        <div class="agu-ad__end"><ng-container *ngTemplateOutlet="ctaTpl" /><ng-container *ngTemplateOutlet="closeTpl" /></div>
    }
    @case ('strip') {
        <!-- `.fx-strip` (P/Member_Hub.html:1383-1391) -->
        <ng-container *ngTemplateOutlet="logoTpl" />
        <div class="agu-ad__txt"><ng-container *ngTemplateOutlet="tagTpl" /><span class="agu-ad__line" [attr.title]="Placement.head">{{ Placement.head }}</span></div>
        <div class="agu-ad__end"><ng-container *ngTemplateOutlet="ctaTpl" /><ng-container *ngTemplateOutlet="closeTpl" /></div>
    }
    @case ('rail-spot') {
        <!-- `.fx-spot` (P/Member_Hub.html:1534-1544); `sub` packs the sub line and the paragraph (SplitRailSpotSub). -->
        <div class="agu-ad__sphead"><ng-container *ngTemplateOutlet="tagTpl" /><ng-container *ngTemplateOutlet="closeTpl" /></div>
        <div class="agu-ad__sprow">
            <ng-container *ngTemplateOutlet="logoTpl" />
            <div>
                <div class="agu-ad__nm">{{ Placement.head }}</div>
                @if (Rail.Line) { <div class="agu-ad__sb">{{ Rail.Line }}</div> }
            </div>
        </div>
        @if (Rail.Body) { <p class="agu-ad__p">{{ Rail.Body }}</p> }
        <div class="agu-ad__spfoot"><ng-container *ngTemplateOutlet="ctaTpl" /></div>
    }
    @case ('in-list-job') {
        <!-- `.jcard.fx-job.v-band` (P/Member_Hub.html:1549-1561); `sub` packs the pill, org line, salary and sponsor (SplitInListJobSub). -->
        <div class="agu-ad__band">{{ TagText }}@if (Job.Sponsor) { <span>· {{ Job.Sponsor }}</span> }<span class="agu-ad__bandend"><ng-container *ngTemplateOutlet="closeTpl" /></span></div>
        <div class="agu-ad__jhead">
            <ng-container *ngTemplateOutlet="logoTpl" />
            <div class="agu-ad__jbody">
                @if (Job.Match) { <div class="agu-ad__jtoprow"><span class="agu-ad__match">{{ Job.Match }}</span></div> }
                <div class="agu-ad__jtitle">{{ Placement.head }}</div>
                @if (Job.Org) { <div class="agu-ad__jorg">{{ Job.Org }}</div> }
            </div>
        </div>
        <div class="agu-ad__jfoot">
            <div class="agu-ad__salary">{{ Job.Salary }}@if (Job.SalaryNote) { <small>{{ Job.SalaryNote }}</small> }</div>
            <ng-container *ngTemplateOutlet="ctaTpl" />
        </div>
    }
    @case ('circles') {
        <!-- `section.fx-circles` (P/Member_Hub.html:1592-1597); `sub` packs the lede and one row per Circle (SplitPackedSub). -->
        <div class="agu-ad__chead">
            <div>
                <ng-container *ngTemplateOutlet="tagTpl" />
                <h3 class="agu-ad__h">{{ Placement.head }}</h3>
                @if (Lede) { <p class="agu-ad__s">{{ Lede }}</p> }
            </div>
            <ng-container *ngTemplateOutlet="ctaTpl" />
        </div>
        <div class="agu-ad__cgrid">
            @for (circle of Circles; track circle.Name) {
                <div class="agu-ad__circle">
                    <div><div class="agu-ad__nm">{{ circle.Name }}</div><div class="agu-ad__ct">{{ circle.Count }}</div></div>
                    @if (circle.Body) { <p>{{ circle.Body }}</p> }
                    <div class="agu-ad__crowend"><button type="button" class="agu-ad__join" [attr.aria-pressed]="IsJoined($index)" (click)="ToggleJoin($index)">{{ JoinLabel($index) }}</button></div>
                </div>
            }
        </div>
    }
    @case ('no-results-line') {
        <!-- `.fx-noalt` (P/Member_Hub.html:1611-1612) -->
        <p class="agu-ad__noalt">{{ Placement.head }} @if (Placement.cta) { <ng-container *ngTemplateOutlet="ctaTpl" /> }</p>
    }
    @case ('detail-circles') {
        <!-- `.fx-dcircles` (P/Member_Hub.html:1633-1644); `sub` packs the note and one row per Circle (SplitPackedSub). -->
        <h2 class="agu-ad__dh">{{ Placement.head }} <ng-container *ngTemplateOutlet="tagTpl" /></h2>
        @if (Lede) { <p class="agu-ad__note">{{ Lede }}</p> }
        <div class="agu-ad__clist">
            @for (circle of Circles; track circle.Name) {
                <div class="agu-ad__crow">
                    <div class="agu-ad__tx"><div class="agu-ad__nm">{{ circle.Name }}</div><div class="agu-ad__ct">{{ circle.Count }}</div></div>
                    <button type="button" class="agu-ad__join" [attr.aria-pressed]="IsJoined($index)" (click)="ToggleJoin($index)">{{ JoinLabel($index) }}</button>
                </div>
            }
        </div>
    }
}
